/* eslint-disable eqeqeq */
export function getCookie(cookieName: string): string {
  const name = `${cookieName}=`;
  const decodedCookie = document ? decodeURIComponent(document.cookie) : '';
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      try {
        return JSON.parse(c.substring(name.length, c.length));
      } catch (e) {
        return c.substring(name.length, c.length);
      }
    }
  }
  return '';
}
